import React from 'react';

const PlatformReEngineering = () => (
  <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
          Platform Re-Engineering
        </h1>
        <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
          <p className="text-lg text-gray-700 mb-6">
            Transform your legacy infrastructure into a modern, scalable, and resilient platform. Our Platform Re-Engineering service focuses on automation, cloud-native adoption, and developer self-service to drive business agility and innovation.
          </p>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li>Legacy system assessment and migration</li>
            <li>Infrastructure as Code (IaC) implementation</li>
            <li>Platform automation and DevOps enablement</li>
            <li>Developer portal and self-service capabilities</li>
          </ul>
          <p className="text-gray-700">
            Modernize your platform to unlock new business opportunities.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default PlatformReEngineering;
